import { render, staticRenderFns } from "./tarifscrea.vue?vue&type=template&id=419bb724&"
import script from "./tarifscrea.vue?vue&type=script&lang=js&"
export * from "./tarifscrea.vue?vue&type=script&lang=js&"
import style0 from "./tarifscrea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports